import AttorneyBioTemplate from '@/components/AttorneyBioTemplate';
import { attorneys } from '@/data/attorneys';

export default function CharlesMarchesePage() {
  return <AttorneyBioTemplate attorney={attorneys['charles-marchese-esq']} />;
}
